import { useSyncExternalStore } from 'react'

/** Live answer to a CSS media query, e.g. whether the chat has room for two panes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}

/** Tailwind `lg`: from here the chat shows the list and the conversation side by side. */
export const useWideScreen = (): boolean => useMediaQuery('(min-width: 1024px)')
